import { useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import chatbot from "../../../images/chatbot.png";
import Airobo from "../../../images/airobo.jpg";
import kidrobo from "../../../images/kidsvr.jpg";

import GlowingBackground from "./BackGraound";

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
};

const fadeRight = {
  initial: { opacity: 0, x: -40 },
  animate: { opacity: 1, x: 0 },
};

const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};

export default function Steampage() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "80vh",
        overflowX: "hidden",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0,
          overflow: "hidden",
        }}
      >
        <GlowingBackground />
      </div>

      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          width: "100%",
          padding: matches ? "0.5rem" : "1.5rem",
          boxSizing: "border-box",
        }}
      >
         <motion.div>
          <div
            style={{
              minWidth: matches ? '100%' : '1200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundSize: '100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              flexWrap: 'wrap',
              boxSizing: 'border-box',
              overflow: 'visible',
              position: 'relative',
              paddingBottom: matches ? '1rem' : '2rem',
              gap: matches ? '12px' : '24px',
              paddingTop: matches ? '0.5rem' : '1.5rem',
            }}
          >
            <motion.div
              variants={fadeRight}
              transition={{ duration: 1 }}
              style={{
                paddingRight: matches ? 0 : '4%',
                textAlign: matches ? 'center' : 'left',
                marginBottom: matches ? '12px' : '0',
              }}
            >
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: 800,
                  fontSize: matches ? '28px' : '64px',
                  lineHeight: '100%',
                  color: '#2F00FF',
                  marginBottom:'2%',
                }}
              >
                STEM Approach
              </Typography>
              <motion.div variants={fadeUp} transition={{ duration: 1 }}>
                <Typography
                  style={{
                    fontFamily:  "Montserrat",
                    fontWeight: 500,
                    fontSize: matches ? '16px' : '28px',
                    color: '#000000',
                  }}
                >
                  Making learning practical, memorable, and
                </Typography>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: -20, scale: 0.8 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                whileHover={{ scale: 1.08 }}
              >
                <Typography
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: 400,
                    fontSize: matches ? '28px' : '60px',
                    color: '#7209B7',
                  }}
                >
                  seriously fun.
                </Typography>

                <motion.svg
                width={matches ? 260 : 600}
                height={40}
                viewBox="0 0 700 40"
                strokeLinecap="round"
                style={{ display: "block", marginLeft:matches?'10%':'0%' }}
              >
                <motion.path
                  d="M0,30 Q300,0 600,30"
                  stroke="#FF006E"
                  strokeWidth={8}
                  fill="transparent"
                  initial={{ pathLength: 0, opacity: 0 }}
                  animate={{ pathLength: 1, opacity: 1 }}
                  transition={{ duration: 1.5, ease: "easeInOut" }}
                  whileHover={{
                    d: "M0,30 Q300,10 600,30",
                    transition: { duration: 0.8 },
                  }}
                />
              </motion.svg>
              </motion.div>
            </motion.div>

            <motion.div
              variants={fadeUp}
              transition={{ duration: 1, delay: 0.4 }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: matches ? '10px' : '16px'
              }}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                style={{
                  width: matches ? 140 : 200,
                  height: matches ? 160 : 215,
                  borderRadius: '12px',
                  backgroundColor: '#F0FFAE',
                  padding: '8px',
                  alignSelf: "flex-start",
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#A3A3F5',
                      borderRadius: '50%',
                      marginBottom:'2%'
                    }}
                  >
                    <img src={chatbot} alt="chatbot" style={{ width: '16px' }} />
                  </div>
                  <Typography
                    style={{
                      fontWeight: 500,
                      fontSize: matches ? '10px' : '16px',
                      color: '#0D5EF4',  fontFamily: "Montserrat",
                    }}
                  >
                    STEM Fact
                  </Typography>
                </div>

                <div style={{ padding: '2px' }}>
                  <Typography
                    style={{
                      fontSize: matches ? '9px' : '12px',
                      lineHeight: '14px',
                      color: '#38393E',
                      marginBottom: '4px',  fontFamily: "Poppins",
                    }}
                  >
                    STEM helps us build robots, explore space, and even code AI.
                  </Typography>
                  <Typography
                    style={{
                      fontSize: matches ? '9px' : '12px',
                      fontWeight: '600',
                      color: '#000000',  fontFamily: "Montserrat",
                    }}
                  >
                    The future starts with STEM.
                  </Typography>
                </div>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, delay: 0.2 }}
                style={{ width: matches ? 140 : 200, height: matches ? 200 : 300 }}
              >
                <img src={Airobo} style={{ borderRadius: '12px', marginTop: '8px', width: '100%' }} />
              </motion.div>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
              style={{
                width: matches ? 140 : 200,
                height: matches ? 200 : 300,
                margin: matches ? '8px' : '10px',
              }}
            >
              <img src={kidrobo} style={{ borderRadius: '12px', width: '100%' }} />
            </motion.div>
          </div>

          <motion.div
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.8 }}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#0C0B0BBD',
              padding: '16px 0',
            }}
          >
            <Typography
              style={{
                width: '80%',
                fontWeight: '700',
                fontFamily: 'Poppins',
                fontSize: matches ? '11px' : '16px',
                textAlign: 'center',
              }}
            >
              STEM isn’t just subjects—it’s a superpower for the real world...
            </Typography>
            <Typography
              style={{
                width: '80%',
                fontWeight: '900',
                textAlign: 'center',
                fontFamily: "Montserrat",
                fontSize: matches ? '16px' : '28px',
                marginTop: '8px',
              }}
            >
              This is education, upgraded!
            </Typography>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
}
